import MainLayouts from 'layouts/MainLayouts'
import IdentitasPasien from 'pages/RiwayatPolaMakan/IdentitasPasien'
import IdentitasPasienBaru from 'pages/RiwayatPolaMakan/IdentitasPasienBaru'
import React from 'react'

function OrderKonselingManual() {
    return (
        <MainLayouts>
            <br/>
            <h2 className='text-center b text-uppercase'> Konseling Baru </h2>
            <IdentitasPasienBaru/>
        </MainLayouts>

    )
}

export default OrderKonselingManual